
const defaultState = {
  isOpen: false,
  event: null,
};


const estimateModal = (state = defaultState, action) => {
  switch (action.type) {
    case 'OPEN_ESTIMATE_MODAL':
      return Object.assign({}, state, { isOpen: true, event: action.event });
    case 'CLOSE_ESTIMATE_MODAL':
      return Object.assign({}, state, { isOpen: false });
    default:
      return state;
  }
};

export default estimateModal;
